import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { TransportOrdersOverview } from './overview';
import { TransportOrderDetails } from './details';
import { TransportOrdersOverviewMaps } from './overviewMaps';
import { TransportOrdersOverviewDoubleScreen } from './overviewDoubleScreen';
import { selectOverviewScreenMode } from '../selectors';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class TransportOrdersPageComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  render() {
    return (
      <Container>
        <Switch>
          <Route
            path="(.*)/transport-orders/:id(.*)"
            render={component => <TransportOrderDetails transportOrderId={parseInt(component.match.params.id, 10)} />}
          />
          <Route component={this.props.doubleScreen ? TransportOrdersOverviewDoubleScreen : TransportOrdersOverview} />
          {/* <Route component={TransportOrdersOverviewDoubleScreen} /> */}
        </Switch>
        {/* <Switch>
          <Route
            path="(.*)/transport-orders/:id(.*)"
            render={component => <TransportOrderDetails transportOrderId={parseInt(component.match.params.id, 10)} />}
          />
          <Route component={TransportOrdersOverviewMaps} />
        </Switch> */}
      </Container>
    );
  }
}

TransportOrdersPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    doubleScreen: selectOverviewScreenMode(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrdersPage = compose(withConnect, withRouter)(TransportOrdersPageComp);
